<script>
  export let text;
  export let link;
</script>

<a href={link}><button>{text}</button></a>


<style>
  button {
    font-family: 'Oswald';
    font-weight: normal;
    background-color: #f7931e;
    color: white;
    text-decoration: none;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    text-transform: uppercase;
    transition: 0.3s ease;
  }

  button:hover {
    scale: 1.17;
  }
</style>